export const CATEGORIES = [
  { id: "alle", label: "Alle", testid: "resource-category-all" },
  { id: "offentlig", label: "Offentlig hjelp", testid: "resource-category-nav" },
  { id: "gjeld", label: "Gjeldsregister", testid: "resource-category-debt" },
  { id: "rettslig", label: "Inkasso & rettigheter", testid: "resource-category-legal" },
  { id: "skjema", label: "Søknadsskjemaer", testid: "resource-category-forms" },
];

export const CATEGORY_LABELS = {
  offentlig: "Offentlig hjelp",
  gjeld: "Gjeldsregister",
  rettslig: "Inkasso & rettigheter",
  skjema: "Søknadsskjema",
};

export const FALLBACK_RESOURCES = [
  { id: "nav-radgivning", title: "NAV Økonomi- og gjeldsrådgivning", category: "offentlig",
    description: "Gratis og uforpliktende rådgivning fra NAV for deg som sliter med gjeld eller har vanskelig for å betale regninger.",
    url: "https://www.nav.no/okonomi-gjeld", phone: "55 55 33 39" },
  { id: "skatteetaten", title: "Skatteetaten — Endre skattekort", category: "offentlig",
    description: "Juster skattetrekket hvis inntekten din har endret seg, for å unngå restskatt eller frigjøre penger hver måned.",
    url: "https://www.skatteetaten.no/person/skatt/skattekort/", phone: null },
  { id: "sifo", title: "SIFO Referansebudsjettet", category: "offentlig",
    description: "Referansebudsjettet (tidligere Standardbudsjettet) viser hva det koster å dekke vanlige utgifter — et godt utgangspunkt for eget budsjett.",
    url: "https://www.oslomet.no/om/sifo/referansebudsjettet", phone: null },
  { id: "gjeldsregisteret", title: "Gjeldsregisteret — Sjekk din usikrede gjeld", category: "gjeld",
    description: "Logg inn med BankID og få gratis, fullstendig oversikt over alle kredittkort og forbrukslån i Norge.",
    url: "https://www.gjeldsregisteret.com/", phone: null },
  { id: "norskgjeld", title: "Norsk Gjeldsinformasjon", category: "gjeld",
    description: "Offisiell portal for oppslag i egne usikrede kreditter, godkjent av Finanstilsynet.",
    url: "https://www.norskgjeld.no/", phone: null },
  { id: "inkassoregisteret", title: "Inkassoregisteret — Se dine inkassosaker", category: "gjeld",
    description: "Logg inn med BankID og få gratis oversikt over inkassosaker og betalingsanmerkninger registrert på deg.",
    url: "https://inkassoregisteret.no/", phone: null },
  { id: "gjeldsordning", title: "Gjeldsordning — Regjeringen.no", category: "rettslig",
    description: "Offisiell informasjon om gjeldsordning for deg med varige betalingsproblemer. Søknaden sendes til namsmannen i kommunen der du bor.",
    url: "https://www.regjeringen.no/no/tema/forbruker/gjeldsordning/id670299/", phone: null },
  { id: "forbrukerradet-inkasso", title: "Forbrukerrådet — Rettigheter ved inkasso", category: "rettslig",
    description: "Oversikt over hva inkassoselskaper har lov til å kreve, salærsatser og dine klagerettigheter.",
    url: "https://www.forbrukerradet.no/forside/okonomi-og-betaling/inkasso-2/", phone: null },
  { id: "finkn-inkasso", title: "Finansklagenemnda Inkasso (tidligere Inkassoklagenemnda)", category: "rettslig",
    description: "Klag på inkassokrav eller gebyrer. Merk: du må først ha klaget skriftlig til inkassoselskapet.",
    url: "https://www.finkn.no/inkasso", phone: "23 13 19 60" },
  { id: "nav-sosialhjelp", title: "NAV — Søk om økonomisk sosialhjelp", category: "skjema",
    description: "Søk digitalt om midlertidig økonomisk sosialhjelp eller nødhjelp hos NAV i kommunen din.",
    url: "https://www.nav.no/okonomisk-sosialhjelp", phone: "55 55 33 33" },
  { id: "nav-soknader", title: "NAV — Alle skjemaer og søknader", category: "skjema",
    description: "Samlet oversikt over NAVs digitale søknader: bostøtte, stønader, barnetrygd og mer.",
    url: "https://www.nav.no/soknader", phone: null },
];

export const CHAPTERS = [
  {
    id: "01",
    title: "Ta grep om hverdagen",
    intro: "Det første steget er å få oversikt. Når du vet hva som kommer inn og hva som går ut, blir valgene enklere.",
    points: [
      "Lag et realistisk budsjett — bruk SIFOs referansebudsjett som mal.",
      "Prioriter bolig, strøm og mat først. Alt annet kan vente.",
      "Ta kontakt med kreditor før forfall — de fleste tilbyr utsettelse eller nedbetalingsplan.",
      "Sjekk om du har rett til bostøtte, barnetrygd eller andre stønader.",
    ],
    links: [
      { label: "SIFO Referansebudsjettet", url: "https://www.oslomet.no/om/sifo/referansebudsjettet" },
      { label: "Bostøtte fra Husbanken", url: "https://www.husbanken.no/person/bostotte/" },
    ],
  },
  {
    id: "02",
    title: "Inkasso og namsmannen",
    intro: "Inkasso følger strenge regler. Du har flere rettigheter enn de fleste tror — og det finnes klageinstanser.",
    points: [
      "Inkassoselskaper kan bare kreve lovlige gebyrer og salærer.",
      "Be alltid om en skriftlig nedbetalingsplan du faktisk kan leve med.",
      "Ved utlegg har du rett til å beholde et minstebeløp til livsopphold.",
      "Uenig i kravet? Klag først til selskapet, deretter til Finansklagenemnda Inkasso — gratis.",
    ],
    links: [
      { label: "Forbrukerrådet om inkasso", url: "https://www.forbrukerradet.no/forside/okonomi-og-betaling/inkasso-2/" },
      { label: "Finansklagenemnda Inkasso", url: "https://www.finkn.no/inkasso" },
    ],
  },
  {
    id: "03",
    title: "Dine rettigheter",
    intro: "Økonomisk hjelp er ikke veldedighet — det er lovfestede rettigheter du kan kreve.",
    points: [
      "Økonomisk sosialhjelp er en rettighet hvis du ikke kan klare deg selv.",
      "Du har rett til livsopphold: mat, bolig og nødvendige utgifter.",
      "NAV har plikt til å veilede deg om dine rettigheter.",
      "Alle kommuner tilbyr gratis gjeldsrådgivning — uforpliktende og konfidensielt.",
    ],
    links: [
      { label: "NAV Økonomi- og gjeldsrådgivning", url: "https://www.nav.no/okonomi-gjeld" },
      { label: "NAV Økonomisk sosialhjelp", url: "https://www.nav.no/okonomisk-sosialhjelp" },
    ],
  },
  {
    id: "04",
    title: "Gjeldsordning steg for steg",
    intro: "Er gjelden varig umulig å betjene, kan en offentlig gjeldsordning gi deg en ny start.",
    points: [
      "Gjeldsordning er for deg med varige betalingsproblemer — ikke bare en dårlig måned.",
      "Søknaden sendes til namsmannen i kommunen din — du trenger ikke prøve alene først.",
      "Du får en nedbetalingsplan, vanligvis over fem år.",
      "Når perioden er over, slettes resten av gjelden som er omfattet.",
    ],
    links: [
      { label: "Om gjeldsordning (Regjeringen.no)", url: "https://www.regjeringen.no/no/tema/forbruker/gjeldsordning/id670299/" },
      { label: "Sjekk gjelden din i Gjeldsregisteret", url: "https://www.gjeldsregisteret.com/" },
    ],
  },
];
